const ENV = process.env.NODE_ENV || 'development';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

const config = {
    development: {
        baseURL: BACKEND_URL,
    },
    production: {
        baseURL: BACKEND_URL,
    }
};

export default config[ENV] || config.development;
